export interface ShortlistData {
  name: string;
  email: string;
  phone: string;
  company: string;
  message: string;
  shortlistIds: string[];
  id: string;
  createdAt: string;
}

export interface Profile {
  id: string;
  candidateName: string;
  email: string;
  phone: string;
  linkedInLink?: string;
  profileUrl?: string;
  summary?: string;
  industries?: string[];
  experiences: Experience[];
  anonymizedProfile?: any;
}

export interface Experience {
  totalDurationMonths: number;
  isCurrent: boolean;
  endYear?: number;
  company: string;
  roles: Role[];
}

export interface Role {
  title: string;
  duration: number;
  isCurrent: boolean;
  endYear?: number;
  startDate?: string | { year: number; month: number };
  endDate?: string | { year: number; month: number };
  isFreelance: boolean;
  employmentStatus: string;
  location: string;
  skills: string[];
  description?: string;
}

export const fetchShortlistById = async (id: string): Promise<ShortlistData> => {
  const response = await fetch(`/api/shortlists/${id}`);
  if (!response.ok) {
    throw new Error('Failed to fetch shortlist');
  }
  return response.json();
};

export const fetchProfileById = async (id: string): Promise<Profile> => {
  const response = await fetch(`/api/profiles/${id}`);
  if (!response.ok) {
    throw new Error('Failed to fetch profile');
  }
  return response.json();
};

export const fetchProfilesByIds = async (ids: string[]): Promise<Profile[]> => {
  const promises = ids.map(id => fetchProfileById(id));
  return Promise.all(promises);
};
